var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st0{fill:gray}")), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(-223.799 -223.914) scale(1.74656)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.71 334.44h32.44v9.31h-32.44v-9.31zm-1.32 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.71 367.41h32.44v9.31h-32.44v-9.31zm-1.32 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.03 334.02h32.45v9.31h-32.45v-9.31zm-1.32 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18V332.7c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.03 399.95h32.45v9.31h-32.45v-9.31zm-1.32 18.82h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.71 400.37h32.44v9.31h-32.44v-9.31zm-1.32 18.82h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18V411c0 4.52 3.67 8.19 8.18 8.19z",
    id: "path12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.03 366.99h32.45v9.31h-32.45v-9.31zm-1.32 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.06 334.02h32.45v9.31h-32.45v-9.31zm-1.32 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18V332.7c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path16"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.06 399.95h32.45v9.31h-32.45v-9.31zm-1.32 18.82h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.06 366.99h32.45v9.31h-32.45v-9.31zm-1.32 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c0 4.51 3.67 8.18 8.18 8.18z",
    id: "path20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.57 238.54h28.95v16.7c0 7.49 6.09 13.59 13.59 13.59s13.59-6.09 13.59-13.59v-16.7h71.49v16.7c0 7.49 6.09 13.59 13.59 13.59 7.49 0 13.59-6.09 13.59-13.59v-16.7h71.49v16.7c0 7.49 6.09 13.59 13.59 13.59s13.59-6.09 13.59-13.59v-16.7h28.95v188.35a3.5 3.5 0 0 1-3.49 3.49H162.06a3.5 3.5 0 0 1-3.49-3.49V238.54Zm46.62-26.2v42.9c0 2.25-1.83 4.08-4.08 4.08s-4.08-1.83-4.08-4.08v-42.9c0-2.25 1.83-4.08 4.08-4.08 1.09 0 2.11.42 2.89 1.2.76.76 1.19 1.79 1.19 2.88zm98.66 0v42.9c0 2.25-1.83 4.08-4.08 4.08s-4.08-1.83-4.08-4.08v-42.9c0-1.09.42-2.11 1.2-2.89.77-.77 1.79-1.19 2.88-1.19 2.25 0 4.08 1.83 4.08 4.08zm98.67 0v42.9c0 2.25-1.83 4.08-4.08 4.08s-4.08-1.83-4.08-4.08v-42.9c0-1.09.42-2.11 1.2-2.89.77-.77 1.79-1.19 2.88-1.19 2.25 0 4.08 1.83 4.08 4.08zm-243.95 1.25v-40.62a3.5 3.5 0 0 1 3.49-3.49h275.43a3.5 3.5 0 0 1 3.49 3.49v56.07h-28.95v-16.7c0-7.49-6.09-13.59-13.59-13.59-3.63 0-7.05 1.42-9.61 3.98a13.494 13.494 0 0 0-3.98 9.61v16.7h-71.49v-16.7c0-7.49-6.09-13.59-13.59-13.59-3.63 0-7.05 1.42-9.6 3.98a13.486 13.486 0 0 0-3.99 9.61v16.7h-71.49v-16.7c0-3.63-1.41-7.04-3.98-9.6a13.486 13.486 0 0 0-9.61-3.99c-7.49 0-13.59 6.1-13.59 13.59v16.7h-28.95v-15.45zm3.49 226.29h275.43c7.16 0 12.99-5.83 12.99-12.99V172.97c0-7.16-5.83-12.99-12.99-12.99H162.06c-7.16 0-12.99 5.83-12.99 12.99v253.92c-.01 7.16 5.82 12.99 12.99 12.99z",
    id: "path22"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.39 334.02h32.44v9.31h-32.44v-9.31zm-1.33 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18V332.7c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c.01 4.51 3.67 8.18 8.18 8.18z",
    id: "path24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.39 366.99h32.44v9.31h-32.44v-9.31zm-1.33 18.81h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c.01 4.51 3.67 8.18 8.18 8.18z",
    id: "path26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.39 399.95h32.44v9.31h-32.44v-9.31zm-1.33 18.82h35.09c4.51 0 8.18-3.67 8.18-8.18v-11.95c0-4.51-3.67-8.18-8.18-8.18h-35.09c-4.51 0-8.18 3.67-8.18 8.18v11.95c.01 4.51 3.67 8.18 8.18 8.18z",
    id: "path28"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 331.59,
    cy: 294.45,
    r: 14.81,
    id: "circle30",
    style: {
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.55,
    cy: 294.45,
    r: 14.81,
    id: "circle32",
    style: {
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.62,
    cy: 294.45,
    r: 14.81,
    id: "circle34",
    style: {
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.66,
    cy: 294.45,
    r: 14.81,
    id: "circle36",
    style: {
      fill: "#e79933"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.45fc8c22a50d6a6e14e2b450c73efb37.svg";
export { ForwardRef as ReactComponent };